import { createRouter, createRoute, createRootRoute, RouterProvider, Outlet } from "@tanstack/react-router";
import LandingPage from "./routes/index";
import { AppPage } from "./routes/app";
import { AuthPage } from "./routes/auth";
import { ParentsPage } from "./routes/parents";
import { SchoolsPage } from "./routes/schools";
import { MerchantsPage } from "./routes/merchants";
import { AboutPage } from "./routes/about";
import DemoPage from "./routes/demo";
import EcosystemPage from "./routes/ecosystem";
import InsightsPage from "./routes/insights";
import { ProductDetailPage } from "./components/landing/product-detail-page";

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", component: LandingPage });
const appRoute = createRoute({ getParentRoute: () => rootRoute, path: "/app", component: AppPage });
const authRoute = createRoute({ getParentRoute: () => rootRoute, path: "/auth", component: AuthPage });
const parentsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/parents", component: ParentsPage });
const schoolsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/schools", component: SchoolsPage });
const merchantsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/merchants", component: MerchantsPage });
const aboutRoute = createRoute({ getParentRoute: () => rootRoute, path: "/about", component: AboutPage });
const demoRoute = createRoute({ getParentRoute: () => rootRoute, path: "/demo", component: DemoPage });
const ecosystemRoute = createRoute({ getParentRoute: () => rootRoute, path: "/ecosystem", component: EcosystemPage });
const productDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: "/ecosystem/$productId", component: ProductDetailPage });
const insightsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/insights", component: InsightsPage });

const routeTree = rootRoute.addChildren([
  indexRoute,
  appRoute,
  authRoute,
  parentsRoute,
  schoolsRoute,
  merchantsRoute,
  aboutRoute,
  demoRoute,
  ecosystemRoute,
  productDetailRoute,
  insightsRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  return <RouterProvider router={router} />;
}
